import { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { EventType } from '@azure/msal-browser';

const MsalEventHandler = () => {
  const { instance } = useMsal();

  useEffect(() => {
    // MSAL failures (interaction_required, login failure) must not end the PMS session: that is
    // our own JWT cookie, re-checked with Microsoft on each silent renewal. Revoking it here used
    // to log users out at their next API call whenever MSAL's silent check failed.
    const callbackId = instance.addEventCallback((event: any) => {
      // Set active account after successful login
      if (event.eventType === EventType.LOGIN_SUCCESS && event.payload?.account) {
        instance.setActiveAccount(event.payload.account);
      }
    });

    // Cleanup on unmount
    return () => {
      if (callbackId) {
        instance.removeEventCallback(callbackId);
      }
    };
  }, [instance]);

  return null; // This component doesn't render anything
};

export default MsalEventHandler;
